import React from 'react';
import { ArrowRight, CheckCircle2, TrendingUp, ShieldCheck, Users } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-slate-900 pt-20 pb-24 overflow-hidden" data-id="element-107">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-108">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center mix-blend-overlay" data-id="element-109"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/50 to-slate-900" data-id="element-110"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-111">
        <div className="text-center max-w-4xl mx-auto" data-id="element-112">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 font-medium text-sm mb-8 animate-fade-in-up" data-id="element-113">
            <span className="relative flex h-2 w-2" data-id="element-114">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" data-id="element-115"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" data-id="element-116"></span>
            </span>
            Accepting New Clients in UK
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6 leading-tight" data-id="element-117">
            Dominate Search Results. <br data-id="element-118" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-300" data-id="element-119">
              Maximize Your ROI.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-120">
            UK's premier SEO & PPC agency driving real business growth. We turn
            traffic into revenue with data-driven strategies.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16" data-id="element-121">
            <a href="https://wa.me/447921876472" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto inline-flex justify-center items-center gap-2 bg-emerald-500 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-emerald-600 transition-all hover:shadow-lg hover:shadow-emerald-500/25 transform hover:-translate-y-1" data-id="element-122">
              Get Free Consultation
              <ArrowRight className="w-5 h-5" data-id="element-123" />
            </a>
            <a href="#services" className="w-full sm:w-auto inline-flex justify-center items-center gap-2 bg-slate-800 text-white px-8 py-4 rounded-lg font-semibold hover:bg-slate-700 transition-all border border-slate-700" data-id="element-124">
              View Our Services
            </a>
          </div>

          {/* Trust Badges */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 border-t border-slate-800 pt-10" data-id="element-125">
            <div className="flex flex-col items-center gap-2 text-slate-400" data-id="element-126">
              <ShieldCheck className="w-8 h-8 text-emerald-500" data-id="element-127" />
              <span className="font-semibold" data-id="element-128">Google Partner</span>
            </div>
            <div className="flex flex-col items-center gap-2 text-slate-400" data-id="element-129">
              <Users className="w-8 h-8 text-emerald-500" data-id="element-130" />
              <span className="font-semibold" data-id="element-131">500+ Clients</span>
            </div>
            <div className="flex flex-col items-center gap-2 text-slate-400" data-id="element-132">
              <TrendingUp className="w-8 h-8 text-emerald-500" data-id="element-133" />
              <span className="font-semibold" data-id="element-134">150% Avg Growth</span>
            </div>
            <div className="flex flex-col items-center gap-2 text-slate-400" data-id="element-135">
              <CheckCircle2 className="w-8 h-8 text-emerald-500" data-id="element-136" />
              <span className="font-semibold" data-id="element-137">10+ Years Exp.</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}